export const THEME_CHANGE_EVENT = "app-theme-change";
export const THEME_STORAGE_KEY = "theme-colors";
export const THEME_MODE_STORAGE_KEY = "theme-mode";
export const THEME_PRIMARY_VAR = "--color-green";
export const THEME_SECONDARY_VAR = "--color-blue";
export const DEFAULT_PRIMARY_COLOR = "#65F4CD";
export const DEFAULT_SECONDARY_COLOR = "#4799E9";
export const DEFAULT_THEME_MODE = "dark";
export type ThemeMode = "dark" | "light";

